/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * An HTTP header supplied when creating an OTEL destination.
 */
export type CreateOtelDestinationHeaderInput = {
  /**
   * Header name.
   */
  name: string;
  /**
   * Write-only header value.
   */
  value: string;
};

/** @internal */
export type CreateOtelDestinationHeaderInput$Outbound = {
  name: string;
  value: string;
};

/** @internal */
export const CreateOtelDestinationHeaderInput$outboundSchema: z.ZodMiniType<
  CreateOtelDestinationHeaderInput$Outbound,
  CreateOtelDestinationHeaderInput
> = z.object({
  name: z.string(),
  value: z.string(),
});

export function createOtelDestinationHeaderInputToJSON(
  createOtelDestinationHeaderInput: CreateOtelDestinationHeaderInput,
): string {
  return JSON.stringify(
    CreateOtelDestinationHeaderInput$outboundSchema.parse(
      createOtelDestinationHeaderInput,
    ),
  );
}
